import AutoAbstractField from "./AutoAbstractField.mjs";
import {Input} from "reactstrap";

const AutoTextField = class extends AutoAbstractField {

	renderField() {
		const rows = this.props.def.rows || false;
		return(
			<Input
				type={ rows ? "textarea" : "text"}
				value={this.state.value}
				onChange={ e => {
					this.setValue( e.target.value );
				}}
				placeholder={ this.props.def.placeholder }
				rows={ rows || undefined}
				onBlur={ e => {
					this.setValue( e.target.value.trim() );
				}}
			/>
		);
	}
}

export default AutoTextField;
